import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background:rgba(29, 100, 216, 0.18);
  transparent: true;
  padding: 1rem 0;
  margin-top: 4rem;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 1rem;

  a {
    color: #333;
    text-decoration: none;
    transition: transform 0.2s;

    &:hover {
      transform: translateY(-3px);
    }

    img {
      width: 24px;
      height: 24px;
    }
  }
`;

const Copyright = styled.p`
  text-align: center;
  color: #666;
  font-size: 0.875rem;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <footer className="shadow-md w-full bottom-0 z-10">
      <SocialLinks>
        <a href="https://tiktok.com/@vioo" target="_blank" rel="noopener noreferrer">
          <img src="/icons/tiktok.png" alt="TikTok" />
        </a>
        {/* <a href="https://instagram.com/vioo" target="_blank" rel="noopener noreferrer">
          <img src="/icons/instagram.png" alt="Instagram" />
        </a> */}
        {/* <a href="https://xiaohongshu.com/vioo" target="_blank" rel="noopener noreferrer">
          <img src="/icons/redbook.png" alt="小红书" />
        </a> */}
      </SocialLinks>
      <Copyright>© {new Date().getFullYear()} Vioo.vip. All rights reserved.</Copyright>
      </footer>
    </FooterContainer>
  );
};

export default Footer; 